module.exports = __webpack_public_path__ + "img/f10.65be3362.png";